import { NostoSectionComponent } from '@theme/nosto-section-base';

/**
 * <ax-slideshow-nosto-bis> — hero slideshow personnalisé par Nosto, rendu
 * SERVER-SIDE via la Section Rendering API (SSR), contrairement à
 * <ax-slideshow-nosto> qui rend côté client depuis un payload JSON.
 *
 * Le contenu des slides vit dans des métaobjets Shopify (`nosto_slideshow` →
 * `nosto_slide`). Nosto ne renvoie QUE le handle du métaobjet (par segment). Le
 * markup morphé est un <ax-slideshow> classique (chargé globalement dans
 * scripts.liquid) qui boote Swiper de lui-même.
 *
 * Toute la mécanique (skeleton SSR → attente du handle → re-render SFR → morph, et
 * le découplage attente-Nosto / fetch) vit dans nosto-section-base.js.
 */
class AxSlideshowNostoBisComponent extends NostoSectionComponent {
  static elementName = 'ax-slideshow-nosto-bis';

  get handleSelector() {
    return '[data-nosto-slideshow-handle], [data-handle]';
  }
}

if (!customElements.get('ax-slideshow-nosto-bis')) {
  customElements.define('ax-slideshow-nosto-bis', AxSlideshowNostoBisComponent);
}
